<template>
  <v-row
    no-gutters
    align="center"
    justify="center"
    class="deltia-card ml-2 mr-2 mb-5 pl-6 pr-6 pt-5 pb-5"
  >
    <!-- Descripción de cada campo -->
    <v-col cols="12" class="hidden-sm-and-down">
      <v-row no-gutters>
        <!-- Columna para el nombre -->
        <v-col cols="12" md="4">
          <p class="font-weight-medium mb-1 text--disabled">
            Nombre
          </p>
        </v-col>
        <!-- Empresa del cliente -->
        <v-col cols="12" md="3">
          <p class="font-weight-medium mb-1 text--disabled">
            Empresa
          </p>
        </v-col>
        <!-- Columna para el número de teléfono -->
        <v-col cols="12" md="3">
          <p class="font-weight-medium mb-1 text--disabled">
            Número de teléfono
          </p>
        </v-col>
        <!-- Columna para la fecha -->
        <v-col
          cols="12"
          md="2"
          :class="{ 'text-right': $vuetify.breakpoint.mdAndUp }"
        >
          <p class="font-weight-medium mb-1 text--disabled">
            Agregado
          </p>
        </v-col>
      </v-row>
    </v-col>
    <!-- Columna para el nombre -->
    <v-col cols="12" md="4">
      <p class="font-weight-medium mb-1 text--disabled hidden-md-and-up">
        Nombre
      </p>
      <p class="content--text font-weight-medium mb-0">
        {{ customer.full_name }}
      </p>
    </v-col>
    <!-- Empresa del usuario -->
    <v-col cols="12" md="3">
      <p class="font-weight-medium mb-1 text--disabled hidden-md-and-up">
        Empresa
      </p>
      <p class="content--text font-weight-medium mb-0">
        {{ customer.company ? customer.company : "Sin empresa" }}
      </p>
    </v-col>
    <!-- Columna para el número de teléfono -->
    <v-col cols="12" md="3">
      <p class="font-weight-medium mb-1 text--disabled hidden-md-and-up">
        Número de teléfono
      </p>
      <p class="content--text font-weight-medium mb-0">
        {{ customer.phone_number || "Sin número de teléfono" }}
      </p>
    </v-col>
    <!-- Columna para la fecha -->
    <v-col
      cols="12"
      md="2"
      :class="{ 'text-right': $vuetify.breakpoint.mdAndUp }"
    >
      <p class="font-weight-medium mb-1 text--disabled hidden-md-and-up">
        Agregado
      </p>
      <p class="content--text font-weight-medium mb-0">
        {{ formatDate(customer.created_at) }}
      </p>
    </v-col>
    <!-- Columna para la descripción -->
    <v-col cols="12" class="mt-3">
      <p class="font-weight-medium mb-1 text--disabled">
        Descripción
      </p>
      <p class="content--text font-weight-medium mb-0">
        {{ customer.description }}
      </p>
    </v-col>
    <!-- Descripción las opciones -->
    <v-col cols="12">
      <v-row no-gutters>
        <!-- Columna para la fecha -->
        <v-col cols="12" class="text-right">
          <p class="font-weight-medium mb-1 text--disabled">
            Opciones
          </p>
        </v-col>
      </v-row>
    </v-col>
    <!-- Columna para los ajustes -->
    <v-col cols="12" class="text-right">
      <v-btn
        @click="
          $router.push({
            name: 'customer-details',
            params: { id: customer._id }
          })
        "
        text
        color="secondary"
        class="pa-0"
      >
        Ver detalles <v-icon>mdi-arrow-right</v-icon>
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
// Importar mixins
import dateFormat from "@/mixins/dateFormat.js";

export default {
  name: "CustomerItem",
  mixins: [dateFormat],
  props: {
    customer: {
      type: Object,
      required: true
    }
  }
};
</script>
